// 🔑 /verification IS A PERMANENT REDIRECT (cleanup Phase 2, Jesse 2026-10-28/29): the classic Verification page is
// gone. An old email link or an old installed app build lands on Documents (#action-needed) — with ?addAssets=1 too
// (Jesse, 2026-11-02: the post-decision "Add assets" is removed) — the mapping in hooks/useGuidedDocuments.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { documentsPathFor } from '../hooks/useGuidedDocuments';

export default function VerificationRoute() {
  const loc = useLocation();
  return <Navigate to={documentsPathFor(true, `/verification${loc.search || ''}`)} replace />;
}
